import { atom } from 'recoil';
import { PlayerScoutingFiltersState } from '../../types/scouting';


export const initialPlayerScoutingFiltersState: PlayerScoutingFiltersState = {
  selectedMinSkillConfidence: [],
  selectedMinConfidence: [],
  selectedMaxAge: [],
  selectedPositions: [],
  selectedRoles: [],
  selectedLeagues: [],
  selectedOrderBy: ['skill_index'],
  selectedOrderByWasExplicitlySet: false,

  selectedClubs: [],
  selectedForm: [],
  selectedPlayingTime: [],
  selectedNationalities: [],
  selectedContractStatus: [],
  isContractStatusToggled: false,

  scoutingViewResultContainerTop: 85,
  isAdvancedFiltersExpanded: false,
  showAdvancedFilters: false,
};


export const playerScoutingFiltersState = atom<PlayerScoutingFiltersState>({
  key: 'playerScoutingFilters',
  default: initialPlayerScoutingFiltersState,
});
